import React from 'react';
import { motion } from 'framer-motion';
import { Coffee, AlertTriangle, Smartphone, UserX } from 'lucide-react';
export function WhyItFailed() {
  const reasons = [{
    icon: <Coffee className="w-6 h-6 text-navy" data-id="element-134" />,
    text: 'El exceso de cafeína solo oculta el cansancio y te genera un "choque" de energía peor a media tarde.'
  }, {
    icon: <AlertTriangle className="w-6 h-6 text-navy" data-id="element-135" />,
    text: 'Intentar "forzar" la voluntad no funciona cuando tu cerebro no tiene el combustible químico correcto.'
  }, {
    icon: <Smartphone className="w-6 h-6 text-navy" data-id="element-136" />,
    text: 'Los descansos mirando redes sociales en realidad cansan más a tu cerebro al saturarlo de dopamina barata.'
  }, {
    icon: <UserX className="w-6 h-6 text-navy" data-id="element-137" />,
    text: 'Las soluciones genéricas no consideran el ritmo de vida y el estrés específico de una mujer que estudia o trabaja.'
  }];
  return <section className="py-20 bg-white" data-id="element-138">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-141">
            Por qué lo que intentaste no funcionó
          </h2>
          <div className="w-24 h-1 bg-mint mx-auto" data-id="element-142"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-143">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="flex items-start p-6 bg-cream rounded-2xl border border-mint/30" data-id="element-144">
              <div className="flex-shrink-0 p-3 bg-mint-light rounded-xl mr-4" data-id="element-145">
                {reason.icon}
              </div>
              <p className="text-navy/80 leading-relaxed pt-1" data-id="element-146">{reason.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}